@if (areInPrRoutes && showPopup && !isAppInstalled) {
  <div class="popuppr" id="popupp">
    <div class="popup-contentpr">
      <div class="d-flex align-items-center" style="gap: 10px;">
        <span id="clossseee" class="material-symbols-outlined closepr" (click)="onClosePopUp()">
          close
        </span>
        <div> <img  class="imgpr" src="./assets/icons/ctPR.png" alt=""></div>
        <div>
          <p class="m-0 ppr">Ciaotickets PR</p>
          <p class="m-0 ppr pwaBannerDesc">{{'general.bannner.message' | translate }}</p>
        </div>
      </div>
      <div (click)="onAddToHomeScreenClick()" class="installpr text-uppercase">{{'general.bannner.install' | translate }} </div>
    </div>
  </div>
}
<app-fuse-main></app-fuse-main>
<notifier-container></notifier-container>
<ng-template #customNotification let-notificationData="notification">
  <app-c-notification [notification]="notificationData">
  </app-c-notification>
</ng-template>

<div class="tap-top top-cls">
  <span class="chevron-up-icon"></span>
</div>
